import { reject } from 'lodash-es';
import { useMutation } from '@apollo/client/react';
import MLink from '@mui/material/Link';
import { makeStyles } from 'tss-react/mui';
import type { GroupComment } from '../../types/GroupComment';
import type { GroupPost } from '../../types/GroupPost';
import { useAppContext } from '../../contexts/app';
import { removeGroupCommentMutation, groupPostCommentsQuery } from '../../apollo/groups';
import ConfirmButton from '../confirm-button';

const useStyles = makeStyles()((theme) => ({
  deleteLink: {
    marginLeft: theme.spacing(1)
  },
  button: {
    paddingBottom: 2
  }
}));

type Props = {
  comment?: GroupComment;
  groupPost?: GroupPost;
};

const DeleteGroupPostCommentLink = ({ comment, groupPost }: Props) => {
  const { loggedInUser } = useAppContext();
  const { classes } = useStyles();
  const [removeGroupComment] = useMutation(removeGroupCommentMutation, {
    update: (proxy, { data: { removeGroupComment: removedComment } }) => {
      // update groupPost query w/ updated membership object
      const groupPostQueryVariables = { id: groupPost.id };
      const data = proxy.readQuery({
        query: groupPostCommentsQuery,
        variables: groupPostQueryVariables,
      });
      proxy.writeQuery({
        query: groupPostCommentsQuery,
        variables: groupPostQueryVariables,
        data: {
          ...data,
          groupPost: {
            ...data.groupPost,
            comments: reject(data.groupPost.comments, ({ id }) => id === removedComment.id)
          }
        }
      });
    }
  });

  if (!groupPost.permissions.editable && (!loggedInUser || comment.user.id !== loggedInUser.id)) {
    return null;
  }

  const handleClick = () => {
    removeGroupComment({
      variables: {
        id: comment.id
      }
    });
  };

  return (
    <span className={classes.deleteLink}>
      <ConfirmButton
        label="Delete"
        buttonComponent={MLink}
        component="button"
        onClick={handleClick}
        className={classes.button}
        confirmMessage="Are you sure you would like to delete this comment?"
      />
    </span>
  );
};

export default DeleteGroupPostCommentLink;
